export default __webpack_public_path__ + "static/media/1588.41db367b.png";